import React, { useState } from "react";
import { Box, IconClose, ImgContainer, ImgPopup } from "./styles";
import { images } from "../../../constants";
import { MdClose } from "react-icons/md";
// import { useNavigate } from "react-router-dom";

const Terms = () => {
  const [popup, setpopup] = useState(false);

  const handlePopup = () => {
    setpopup((popup)=>false);
  };

  // const navigate = useNavigate();
  //     const handleNavigate = (url) => {
  //       navigate(url);
  //     };


  return (
    popup && (
      <Box>
        <ImgContainer>
        <IconClose onClick={handlePopup}>
          <MdClose size={42} />
        </IconClose>
          <ImgPopup src={images.popup} />
          {/* <ConfirmButton text="OK" type="button" onClick={handlePopup} /> */}
        </ImgContainer>
      </Box>
    )
  );
};

export default Terms;
